
import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'

import ErrorHandler from '@/services/ErrorHandlerService'
import { INotificationService } from '@/services/NotificationService'

import { Extra } from '../../models/user'
import ExtrasService from '../../services/ExtrasService'
import BlueButton from '../Atomic/BlueButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '../Atomic/CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'
import GreenButton from '@/components/Atomic/GreenButton.vue'

@Component({
  components: {
    GreenButton,
    BlueButton,
    RedButton,
    CardTitle,
    ProgressLinear,
  },
})
export default class DeleteExtra extends Vue {
  @Prop() public readonly pending!: boolean
  @Prop(Function) public readonly onClose!: () => void
  private dialog: boolean = false
  private isPending: boolean = false

  private errorHandler = new ErrorHandler()
  private $notificationService!: INotificationService

  @Prop() private readonly account!: Extra

  private async deleteAccount() {
   this.isPending = true
   try {
        await ExtrasService.delete(this.account.personne_id)
        this.$notificationService.success(
          this.$t('EXTRAS.DeletionSuccess').toString(),
        )
        this.hide()
      } catch (error: any) {
        this.errorHandler.handle(this, error.response.data.code, true)
      }
   this.isPending = false
  }

  private hide() {
    this.onClose()
    this.dialog = false
  }
 }
